import { memo, useEffect, useRef } from "react";
import { Sparkles, Terminal } from "lucide-react";
import { ImpactReportButton } from "@/components/project/ReviewHistory";

export function StreamPanel({ running, streamText }) {
  const ref = useRef(null);
  useEffect(() => { if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [streamText]);
  if (!running && !streamText) return null;
  return (
    <div className="sc-card p-5" data-testid="stream-panel">
      <div className="flex items-center gap-2 mb-2">
        <Terminal className="w-4 h-4 text-amber-400" /><div className="label-cap">Live Scan Stream</div>
        {running && <span className="text-[10px] font-mono text-amber-400 animate-pulse">● TOKENS FLOWING</span>}
      </div>
      <div ref={ref} className="max-h-56 overflow-y-auto bg-slate-950/80 border border-slate-800 rounded p-3 font-mono text-[11px] leading-relaxed text-slate-300 whitespace-pre-wrap" data-testid="stream-output">
        {streamText || <span className="text-slate-600">Model output will appear here as it streams…</span>}
      </div>
    </div>
  );
}

export function ResultPanel({ result }) {
  if (!result) return null;
  return (
    <div className="sc-card p-5" data-testid="review-result-panel">
      <div className="flex items-center gap-2 mb-2"><Sparkles className="w-4 h-4 text-amber-400" /><div className="label-cap">Executive Summary</div></div>
      <p className="text-sm text-slate-300 leading-relaxed">{result.summary}</p>
      <div className="mt-3 text-xs font-mono text-slate-500 flex items-center justify-between gap-2"><span>{result.findings_count} findings created</span>
        {result.mode === "addendum_review" && result.run_id && <ImpactReportButton runId={result.run_id} />}</div>
    </div>
  );
}

export const FindingsPreview = memo(function FindingsPreview({ findings }) {
  return (
    <div className="sc-card p-5">
      <div className="label-cap mb-3">Latest Findings</div>
      <div className="space-y-2 max-h-72 overflow-y-auto">
        {findings.slice(0, 15).map((f) => (
          <div key={f.id} className="border border-slate-800 rounded-md p-3" data-testid={`finding-preview-${f.id}`}>
            <div className="flex items-center gap-2 mb-1">
              <span className={`px-1.5 py-0.5 rounded text-[10px] font-mono font-bold sev-${f.severity}`}>{f.severity?.toUpperCase()}</span>
              <span className="text-xs font-mono text-slate-500">{f.csi_division} · p.{f.source_page}</span>
            </div>
            <div className="text-sm text-slate-100 font-semibold">{f.title}</div>
            <div className="text-xs text-slate-400 mt-1 line-clamp-2">{f.why_it_matters}</div>
          </div>
        ))}
        {!findings.length && <div className="text-sm text-slate-500">Run a scan to generate findings.</div>}
      </div>
    </div>
  );
});
